var React = require('react');
var Router = require('react-router');
var Route = Router.Route;
var DefaultRoute = Router.DefaultRoute;
var handlers ={
    Application: require('../components/handlers/Application.jsx'),
    Home: require('../components/handlers/Home.jsx'),
    Scoreboard: require('../components/handlers/Scoreboard.jsx'),
    Gamecast: require('../components/handlers/Gamecast.jsx')
};

var routes = (
    <Route name="app" path="/?" handler={handlers.Application}>
        <Route name="gamecast" handler={handlers.Gamecast}/>
        <Route name="scoreboard" path=":league/scoreboard?" handler={handlers.Scoreboard}/>
        <Route name="match" path="/rugby/:section/?" handler={handlers.Gamecast}/>
    <DefaultRoute name="home" handler={handlers.Gamecast}/>
    </Route>
);

module.exports = routes;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/configs/routes.jsx
 **/